// extracted by mini-css-extract-plugin
module.exports = {"menuListContainer":"az_cgb","link":"az_dgb"};